import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getVehiculosTransportista`, method: 'GET', body: null, token: token})
}